import React, { useState, useEffect } from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import SchoolIcon from '@mui/icons-material/School';
import MapIcon from '@mui/icons-material/Map';
import SendIcon from '@mui/icons-material/Send';
import QueueIcon from '@mui/icons-material/FormatListBulleted';
import NotificationsIcon from '@mui/icons-material/Notifications';
import EmailIcon from '@mui/icons-material/Email';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PetsIcon from '@mui/icons-material/Pets';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import './Menu.css';

const Menu = () => {
    const location = useLocation();
    const [selectedIndex, setSelectedIndex] = useState(location.pathname);
    const [permissions, setPermissions] = useState([]);
    const token = localStorage.getItem('token');

    useEffect(() => {
        const fetchPermissions = () => {
            let permissions = [];
            try {
                permissions = JSON.parse(localStorage.getItem('permissions')) || [];
            } catch (error) {
                console.error('Error parsing permissions:', error);
                permissions = [];
            }
            setPermissions(permissions);
        };

        fetchPermissions();
    }, []);

    useEffect(() => {
        setSelectedIndex(location.pathname);
    }, [location]);

    const handleListItemClick = (path) => {
        setSelectedIndex(path);
    };

    const canAccess = (permission) => {
        if (permission === 'corsi-insegnante') return true;
        if (permissions.includes('all')) return true;
        return permissions.includes(permission);
    };

    const MenuItemCustom = ({ to, icon: Icon, iconColor, text, permission, external }) => {
        if (permission && !canAccess(permission)) return null;

        const isActive = selectedIndex === to;
        const componentProps = external
            ? { component: 'a', href: to }
            : { component: Link, to: to };

        return (
            <ListItem
                button
                {...componentProps}
                className={`menu-item ${isActive ? 'active-item' : ''}`}
                onClick={() => !external && handleListItemClick(to)}
            >
                <ListItemIcon>
                    <Icon sx={{ color: isActive ? 'white' : iconColor, fontSize: 24 }} />
                </ListItemIcon>
                <ListItemText primary={text} />
            </ListItem>
        );
    };

    return (
        <Box className="menu-container">
            <Box className="menu-toolbar-spacer" />
            <List className="menu-list">
                <MenuItemCustom to="/dashboard" icon={HomeIcon} iconColor="#1565c0" text="Dashboard" permission="dashboard" />
                <MenuItemCustom to="/gestione-lezioni" icon={SchoolIcon} iconColor="#ff9800" text="Gestione Lezioni" permission="dashboard" />
                <MenuItemCustom to="/corsi-caricati" icon={SchoolIcon} iconColor="#2e7d32" text="Magic Teachers" permission="corsi-caricati" />
                <MenuItemCustom to="/globalroadmap" icon={MapIcon} iconColor="#6a1b9a" text="Roadmap Globale" permission="corsi-caricati" />
                <MenuItemCustom to="/mt-inviomessaggi" icon={SendIcon} iconColor="#00838f" text="Invio messaggi MT" permission="mt-inviomessaggi" />
                <MenuItemCustom to="/magic-teachers-queue" icon={QueueIcon} iconColor="#4527a0" text="Coda messaggi MT" permission="magic-teachers-queue" />
                <MenuItemCustom to="/notifications" icon={NotificationsIcon} iconColor="#ef6c00" text="Notifiche" />
                <MenuItemCustom to="/template-email" icon={EmailIcon} iconColor="#c62828" text="Template Email" permission="template-email" />
                <MenuItemCustom to="/corsi-insegnante" icon={MenuBookIcon} iconColor="#e65100" text="I miei corsi" />
                <MenuItemCustom to="/miei-dinoalunni" icon={PetsIcon} iconColor="#ad1457" text="I miei DinoAlunni" />
                <MenuItemCustom to="/areadownload" icon={CloudDownloadIcon} iconColor="#1565c0" text="Area Download Materiali" />
                <MenuItemCustom
                    to={`https://www.hocus-lotus.edu/area-magic?token=${token}`}
                    icon={AutoAwesomeIcon}
                    iconColor="#ff6f00"
                    text="Area Magic"
                    external
                />
            </List>
        </Box>
    );
};

export default Menu;
